import "./LocalSeoConsultantCarlisle.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Methodology from "./sections/Methodology";
import CarlisleLandscape from "./sections/CarlisleLandscape";
import Benefits from "./sections/Benefits";
import Faq from "./sections/Faq";
import Consultation from "./sections/Consultation";
import Servicesgrid from "./sections/Servicesgrid";
import Carlisle from "./sections/Carlisle";
import CarlisleMarketAnalysis from "./sections/CarlisleMarketAnalysis";
import LocalImpact from "./sections/LocalImpact";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantCarlislePage() {
  return <div>
      <Header />
      <Services />
      <Methodology />
      <CarlisleLandscape />
      <Benefits />
      <Faq />
      <Consultation />
      <Servicesgrid />
      <Carlisle />
      <CarlisleMarketAnalysis />
      <LocalImpact />
      <Footer />
    </div>;
}